import React from "react";
import { Truck, Sparkles } from "lucide-react";
import { useI18n } from "../i18n/I18nProvider";

const PromoBanner = () => {
    const { t } = useI18n();
    const text = t("promo_banner");
    return (
        <div
            data-testid="promo-banner"
            className="relative overflow-hidden bg-gradient-to-r from-[#FF5722] via-[#E64A19] to-[#FF5722] text-white"
            style={{ backgroundSize: "200% 100%", animation: "promoBgShift 8s ease-in-out infinite" }}
        >
            {/* Diagonal shimmer streak */}
            <div className="absolute inset-0 pointer-events-none promo-shimmer" aria-hidden="true" />

            <div className="relative max-w-[1320px] mx-auto px-5 md:px-8 min-h-[96px] flex items-center justify-center gap-3 md:gap-4">
                <Truck
                    className="h-7 w-7 md:h-8 md:w-8 shrink-0 drop-shadow-sm"
                    strokeWidth={2}
                    style={{ animation: "promoTruckBob 2.4s ease-in-out infinite" }}
                />
                <span
                    className="font-display text-center text-lg md:text-2xl tracking-tight leading-tight promo-text-glow"
                >
                    {text}
                </span>
                <Sparkles
                    className="h-5 w-5 md:h-6 md:w-6 shrink-0 text-yellow-200"
                    strokeWidth={2}
                    style={{ animation: "promoSparkle 1.8s ease-in-out infinite" }}
                />
            </div>
        </div>
    );
};

export default PromoBanner;
